<ng-content></ng-content>
<option *ngFor="let item of pledgeTypes" [value]="item.id">{{item.name}}</option>
